<div class="import-uses-values-table-container">
    <div *ngIf="validationData$ | async as validationData" class="wrap">
        <div class="table flex column">
            <div class="row header flex align-centre">
                <div class="cell flex" style="width: 10%">Entity Type</div>
                <div class="cell flex" style="width: 30%">Entity Name</div>
                <div class="cell flex" style="width: 60%">Description</div>
            </div>
            <div class="table-body">
                <div class="row body flex" *ngFor="let row of validationRows">
                    <div class="cell flex align-center between" style="width: 10%"
                        [ngClass]="{ 'red-text': !row?.importValidationResult?.isEntityTypeAllowed || !row?.importValidationResult?.noSpecialCharactersInEntityType }">
                        {{ row?.entityType }}
                    </div>
                    <div class="cell flex align-center between" style="width: 30%"
                        [ngClass]="{ 'red-text': !row?.importValidationResult?.isEntityNameSet || !row?.importValidationResult?.isEntityExists || !row?.importValidationResult?.isUnique || !row?.importValidationResult?.noSpecialCharactersInEntityName }">
                        {{ row?.entityName }}
                    </div>
                    <div class="cell flex align-center between" style="width: 60%"
                        [ngClass]="{ 'red-text': !row?.importValidationResult?.isDescriptionValid || !row?.importValidationResult?.noSpecialCharactersInDescription }">
                        {{ row?.description }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<app-import-footer
    [templateType]="ImportTemplateType.ZONE_DESCRIPTIONS"
    [showValidationIcon]="(validationData$ | async) !== null"
    [canImport]="canImport"
    [showValidateButton]="showValidateButton"
    (uploadFile)="openDialog()"
    (importData)="importData()"
    (validateZoningCode)="validateZC()"
    (clearTable)="clearTable()"></app-import-footer>
